// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qj_a bhk_su bhk_kv bhk_kw","PostDetailRight__brandDaysPosts":"qj_b bhk_su bhk_kv bhk_kw"};